module.exports = __webpack_public_path__ + "img/1726044361626-screenshot-1726044230990.png.c63d416f.webp";